import  React, {
        useState, 
        useEffect, 
        }                                   from "react";
import      Style                           from "components/UI/main.module.scss";
import  {   Spinner,
            GetSystemLabel,
            GetAppLang,
        }                                   from "Utilities/utils";   
import  {   DisplayContent,}                from "components/ContentEditor/contentEditor"; 
import {    getApplicationDocumentation}    from "./documentationService";
import { useModal }                         from "components/Covers/genericModal";
import { ModalContent,}                     from "components/Modal/modal";

export const ApplicationDocumentation       = () => {
    const [ mount,          setMount                ]       = useState(false);
    const [isLoading,   setIsLoading]                       = useState(true);
    const [content, setContent]                             = useState(null);   
    const { showModal, hideModal                    }       = useModal();    

    const appLang                      = GetAppLang();
    const getDocumentation             = async () => {
        try {
            let payload = await getApplicationDocumentation();
            if (payload) {
                if (payload.Status.Code === 0) {
                    const _content = JSON.parse(payload.Response.Content.Body);
                    setContent(_content[`${appLang}`]?.body);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    
    useEffect(() => {
        if(!mount) {
            getDocumentation();
            setIsLoading(false);
            setMount(true);
        }
    }, []);

    return (
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment> 
        :
            <DisplayContent 
                    ContentClass={[Style.text_body].join(" ")}
                    Content={content} 
            />
    );
};  